module.exports = __webpack_public_path__ + "img/case6.ac3567be.png";